import React, { useState } from 'react';

const EmailSubscription = ({ darkMode }) => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setMessage('Email je povinný');
      setIsSuccess(false);
      return;
    }

    setIsLoading(true);
    setMessage('');

    try {
      const response = await fetch('https://motivacna-backend.vercel.app/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, name }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message);
        setIsSuccess(true);
        setEmail('');
        setName('');
      } else {
        setMessage(data.error || 'Nastala chyba pri prihlásení');
        setIsSuccess(false);
      }
    } catch (error) {
      console.error('Chyba pri prihlásení:', error);
      setMessage('Nastala chyba pri prihlásení na odber');
      setIsSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="email-subscription">
      <div className="subscription-card">
        <div className="subscription-header">
          <h3>📧 Denné motivačné citáty</h3>
          <p>Prihlaste sa na odber a dostávajte každý deň nový motivačný citát priamo do vašej emailovej schránky!</p>
        </div>

        <form onSubmit={handleSubmit} className="subscription-form">
          <div className="form-group">
            <label htmlFor="name">
              <span className="label-icon">👤</span>
              Meno (voliteľné):
            </label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Vaše meno"
              className="form-input"
              disabled={isLoading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">
              <span className="label-icon">📧</span>
              Email:
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="vas@email.com"
              className="form-input"
              required
              disabled={isLoading}
            />
          </div>

          <button
            type="submit"
            className="subscription-button"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="loading-spinner"></span>
                Prihlasovanie...
              </>
            ) : (
              <>
                <span className="button-icon">📧</span>
                Prihlásiť sa na odber
              </>
            )}
          </button>
        </form>

        {message && (
          <div className={`subscription-message ${isSuccess ? 'success' : 'error'}`}>
            {isSuccess ? '✅' : '❌'} {message}
          </div>
        )}

        <div className="subscription-features">
          <div className="feature">
            <span className="feature-icon">🌅</span>
            <span>Denné citáty ráno</span>
          </div>
          <div className="feature">
            <span className="feature-icon">🎯</span>
            <span>Rôzne kategórie</span>
          </div>
          <div className="feature">
            <span className="feature-icon">🚫</span>
            <span>Žiadny spam</span>
          </div>
          <div className="feature">
            <span className="feature-icon">✋</span>
            <span>Odhlásenie kedykoľvek</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailSubscription;
